import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, IconButton, Popover } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import DeleteConversation from "./DeleteConversation";
import useUser from "../../../hooks/useUser";

export default function ConversationMenu({ convoId, senderId }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { roles, profile } = useUser();
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    event.stopPropagation(); // prevent ListItem click
    setAnchorEl(event.currentTarget);
  };

  if (roles.user) {
    return null;
  }
  //This is here because backend doesn't allow deletion of convos that the User is not the Sender for.
  if (profile.id !== senderId) {
    return null;
  }

  return (
    <>
      <IconButton edge="end" onClick={handleMenuOpen} title={t("OpenMenu")}>
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box p={1}>
          <DeleteConversation
            convoId={convoId}
            handleMenuClose={() => handleMenuClose()}
          />
        </Box>
      </Popover>
    </>
  );
}
